import { PinFormDirectRedirect as ConfirmPinDirectRedirect } from '@features/otp-verification';
import { VoucherNew } from '@pages/VoucherNew';
import { VoucherPinNew } from '@pages/VoucherPinNew';
import { VoucherThankYou } from '@pages/VoucherThankYou';
import { ThreeDSAdyenRedirect } from '@features/card-subscription';
import { DCBUnsubscribeOTP } from '@pages/DCBUnsubscribeOTP';
import { DCBUnsubscribeCountry } from '@pages/DCBUnsubscribeCountry';
import { BeginUnsubscribe } from '@pages/BeginUnsubscribe';
import { DCBUserDetails } from '@pages/DCBUserDetails';
import { DCBUnsubscribe } from '@pages/DCBUnsubscribe';
import { NotFoundPage } from '@pages/NotFoundPage';
import { ThankYouParent } from '@pages/ThankYouParent';
import { Unsubscribe } from '@pages/Unsubscribe';
import { ConfirmPin } from '@pages/ConfirmPin';
import { WelcomeParent } from '@pages/WelcomeParent';

export const remainingRoutes = [
  { path: '/voucher', component: VoucherNew },
  { path: '/voucher/pin', component: VoucherPinNew },
  { path: '/voucher/congrats', component: VoucherThankYou },

  { path: '/unsubscribe', component: Unsubscribe },
  { path: '/cc/unsubscribe', component: Unsubscribe },

  { path: '/dcb/unsubscribe/:country', component: DCBUnsubscribeCountry },
  { path: '/dcb/unsub/otp', component: DCBUnsubscribeOTP },
  { path: '/dcb/user-details', component: DCBUserDetails },
  { path: '/dcb/unsubscribe/master/:token', component: DCBUnsubscribe },

  { path: '/confirm-pin', component: ConfirmPin },
  { path: '/cc/welcome', component: WelcomeParent },

  { path: '/thankyou', component: ThankYouParent },
  { path: '/thankyou/:lang/:sessionId', component: ThankYouParent },
  { path: '/thankyou/:sessionId', component: ThankYouParent },

  { path: '/subscribers/inapp/unsubscribe/begin', component: BeginUnsubscribe },

  { path: '/adyenredirect', component: ThreeDSAdyenRedirect },

  { path: '/special/confirm-pin', component: ConfirmPinDirectRedirect },

  { path: '/not-found', component: NotFoundPage },

  { path: '/not-found/:lang', component: NotFoundPage },
];
